import { AuditLog as ReusableAuditLog } from "~/components/Auditlog/Auditlog";
import { useOrgSettingsOutletContext } from "./settings";

export function AuditLog() {
  const { org } = useOrgSettingsOutletContext();
  return (
    //AuditLog is being reused in both the space and org level
    <ReusableAuditLog {...{ resourceMrn: org.mrn }} />
  );
}
